import React from "react"
  import {
    Container,
    Col,
    Row} from 'reactstrap';
    import {isMobile} from 'react-device-detect';
    import Database from "./database/Database"

    class Part1 extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                mobile:isMobile,
                feedback:false,
                figure:"0",
                data1:""
            }
            this.handleQuestion1 = this.handleQuestion1.bind(this);  
          }

          componentDidMount() {
            fetch("./data/data1.js")
                .then(response => response.json())
                .then(data => {this.setState({
                    data1: data
                })})
                console.log(this.state.data1)
        }
        
          handleQuestion1(param){
            this.setState({
                figure: param,
                feedback: true
            });
            const scriptURL =
              `https://script.google.com/macros/s/AKfycby0kfnJ_QpsQFxjE5yUYoUvN1V--LIaCU5Yk4CjjnSMS7b6PyM/exec?overall=${0}&question0=${param}&question1=${0}&question2=${0}&question3=${0}&question4=${0}`;
            fetch(scriptURL)
              .then(response => console.log("Success!", response))
              .catch(error => console.error("Error!", error.message));
        }

            handleArabic(){
              this.setState(prevState => {
                  return {notArabic: !prevState.notArabic}
              })}
        render()
        {   
            let textselect= this.state.mobile?<p style={{opacity:this.state.feedback?0:1}} className="aliagray text-center">TAP TO SELECT</p>:<p style={{opacity:this.state.feedback?0:1}}className="aliagray text-center">CLICK TO SELECT</p>;
            let thankyou=this.state.feedback?<p className="text-center font-600 pad20 display-5">Thank you for your feedback</p>:<p className="text-center font-600 pad20 display-5">&nbsp;</p>
let feedquestion1 = this.state.feedback?<Row className="abso">
<Col xs="3"><div className={`${this.state.figure==="1" ? 'choiceselected' : ''}`}><p className="text-center display-4">Cases</p><img src='./jpg/thumb1.png' className="fluid" alt=""/></div></Col>
<Col xs="3"><div className={`${this.state.figure==="2" ? 'choiceselected' : ''}`}><p className="text-center display-4">Deaths</p><img src='./jpg/thumb2.png' className="fluid" alt=""/></div></Col>
<Col xs="3"><div className={`${this.state.figure==="3" ? 'choiceselected' : ''}`}><p className="text-center display-4">Recovered</p><img src='./jpg/thumb3.png' className="fluid" alt=""/></div></Col>
<Col xs="3"><div className={`${this.state.figure==="4" ? 'choiceselected' : ''}`}><p className="text-center display-4">Active cases</p><img src='./jpg/thumb4.png' className="fluid" alt=""/></div></Col>
</Row>:
<Row className="abso">
<Col xs="3"><div onClick={() => { this.handleQuestion1('1') }} className="choiceselect"><p className="text-center display-4">Cases</p><img src='./jpg/thumb1.png' className="fluid" alt=""/></div></Col>
<Col xs="3"><div onClick={() => { this.handleQuestion1('2') }} className="choiceselect"><p className="text-center display-4">Deaths</p><img src='./jpg/thumb2.png' className="fluid" alt=""/></div></Col>
<Col xs="3"><div onClick={() => { this.handleQuestion1('3') }} className="choiceselect"><p className="text-center display-4">Recovered</p><img src='./jpg/thumb3.png' className="fluid" alt=""/></div></Col>
<Col xs="3"><div onClick={() => { this.handleQuestion1('4') }} className="choiceselect"><p className="text-center display-4">Active cases</p><img src='./jpg/thumb4.png' className="fluid" alt=""/></div></Col>
</Row>
          return (
            <div>
                <Container fluid><h2 className="text-center newsection"><span className="display-2 home-4">PART ONE</span></h2>
                </Container>
                <Container id="whatsbeingcounted" fluid>
                    <Container>
                        <Row className="justify-content-center align-items-center">
                            <Col lg="10" xs="12" className="text-left no-padding">
                                <p className="display-2 aliagray home-2 text-center">
                                What do we know?
                                </p>
                                <p>
                                Every day, thousands of headlines show the latest figures on the coronavirus. For most readers, the numbers are growing at such a dizzying rate that it is easy to feel overwhelmed.
                                </p>
                                <p>
                                If there was ever a time when we needed clear and reliable data, it's now.
                                </p>
                                <p>
                                How individuals and governments interpret and act upon this data will not only help us stay safe but will ultimately be necessary to end the global coronavirus pandemic.
                                </p>
                                <p className="text-center font-600 pad30 display-5">
                                THERE IS A LOT OF UNCERTAINTY
                                </p>
                                <img src='./jpg/uncertainty.gif' className="fluid" alt=""/>
                                <br/>
                                <p>
                                If you did not know this already, <span className="font600">the coronavirus numbers being reported are not facts - but they’re the best we’ve got.</span>
                                </p>
                                <p>
                                No single dataset exactly represents the reality on the ground. Every day, thousands of healthcare workers, government agencies and researchers are each collecting, processing and sharing what they know about the virus. The goal is to gather the most reliable data that can help people understand the outbreak as it evolves.
                                </p>
                                <p>
                                The more countries collect and share their experiences, the closer to reality we should get.  
                                </p>
                                <p>
                                    Al Jazeera, like many other news networks, primarily uses the <a href="https://github.com/CSSEGISandData/COVID-19" target="_blank" rel="noopener noreferrer">Johns Hopkins University coronavirus dataset</a>, which combines figures from the <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019" target="_blank" target="_blank" rel="noopener noreferrer">World Health Organization (WHO)</a>, the <a href="https://www.cdc.gov/coronavirus/2019-nCoV/index.html" target="_blank" target="_blank" rel="noopener noreferrer">US Centers for Disease Control and Prevention (CDC)</a>, the <a href="https://www.ecdc.europa.eu/en/covid-19-pandemic" target="_blank" target="_blank" rel="noopener noreferrer">European Centre for Disease Prevention and Control (ECDC)</a> as well as several other local media and government sources.
                                </p>    
                            </Col>
                        </Row>
                    </Container>
                </Container>

                <Container fluid><h2 className="text-center newsection"><span className="display-2 home-4">PART TWO</span></h2>
                </Container>
                <Container id="whatsbeingcounted" fluid>
                    <Container>
                        <Row className="justify-content-center align-items-center">
                            <Col lg="10" xs="12" className="text-left no-padding">
                                <p className="display-2 aliagray home-2 text-center">
                                What do the numbers mean?
                                </p>
                                <p>
                                The most widely reported numbers are the <span className="font600">confirmed cases</span>, <span className="font600">deaths</span>, <span className="font600">recoveries</span> and <span className="font600">active cases</span>. We illustrate what these terms mean in the section below.	
                                </p>

                                <Row className="boxcard">
                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>
                                    <p className="text-center font-600 pad30 display-5">
                                    {Database[5].data1}
                                    </p>
                                    <img src='./jpg/confirmed.gif' className="fluid" alt=""/>
                                    <br/>
                                    <br/>
                                        <p>
                                        <span className="font600">Confirmed cases are the number of people who have tested positive.</span>
                                        </p>
                                        <p>
                                        One of the stealthiest characteristics of the coronavirus is that it can be spread with little to no symptoms. This means that the number of people worldwide who are actually infected is probably much higher than the official confirmed cases.
                                        </p>
                                        <p>
                                        <span className="font600">If you have not been tested, you are not counted. </span>
                                        </p>
                                        <p>
                                        Viruses, including COVID-19, tend to spread at an exponential rate, which means they multiply really quickly. On March 6, the world had 100,000 confirmed cases, one month later there were one million, and if the virus continues to grow at this rate, this number could reach 10 million by May.
                                        </p>
                                        <p>
                                            That is why governments in many parts of the world have imposed nationwide lockdowns to <span className="font600">slow down the rate of infection or "flatten the curve"</span>.
                                        </p>
                                    </section>
                                        </Col>
                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>
                                    <p className="text-center font-600 pad30 display-5">
                                    CONFIRMED DEATHS
                                    </p>
                                    <img src='./jpg/death.gif' className="fluid" alt=""/>
                                    <br/>
                                    <br/>
                                    <p><span className="font600">Reporting deaths is a sensitive process.</span></p>
                                    <p>
                                        Every country has its own methods for reporting, which include reviewing a patient's medical records and informing family members before releasing any figures.
                                    </p>
                                    <p>
                                    Leading infectious disease experts have already warned that, despite strict physical distancing measures, the world could still face hundreds of thousands of deaths - if not millions.
                                    </p>
                                    <p>
                                    Just like confirmed cases, <span className="font600">the actual number of deaths is almost certainly higher than what is being reported.</span>
                                    </p>
                                    <p>
                                        Several reports have also emerged of undercounting. These include many cases where people are dying at home despite showing unmistakable COVID-19 symptoms.
                                    </p>
                                    </section>
                                    </Col>
                                </Row>
                                <br/>
                                <p className="text-center font-600 pad30 display-5">
                                THE LAG EFFECT
                                    </p>
                                    <p>
                                    What we are observing today is a result of actions taken a few weeks ago. </p>
                                    <p>
                                    <span className="font600">A reduction in infections today should lead to fewer deaths weeks from now.</span>
                                    </p>

                                <img src='./jpg/lag.gif' className="fluid" alt=""/>
                                <p className="text-center font-600 pad30 display-5">HOW DANGEROUS IS THE VIRUS?</p>
                                
                                <p><span className="font600">If someone contracts COVID-19, how likely is that person to die? </span></p>
                                <p>At the start of the outbreak, a lot of attention was focused on comparing the death rate from COVID-19 to the death rate for other known diseases. While this number is hugely important for us to grasp how concerned we should all be, it is easily miscalculated.</p>
                                <p>Epidemiologists, who study health and diseases, have two measurements to calculate the risk of death, the <span className="font600">case-fatality-rate (CFR)</span> and the <span className="font600">infection-fatality-rate (IFR).</span></p>
<br/>
                                <Row className="boxcard">
                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>
                                    <img src='./jpg/cfr.png' className="fluid" alt=""/>
                                    <br/>
                                    <br/>
                                        <p>
                                        <span className="font600">The case-fatality-rate (CFR) is the proportion of people who die out of those who test positive.</span>
                                        <p>
                                        </p>
                                        If 100 people test positive and 10 people die then this makes the CFR 10%. The big problem with this number is that unlike most other diseases that have ended, new COVID-19 cases and deaths are being reported every day.
                                        </p>
                                        <p>
                                        <span className="font600">This makes COVID-19's mortality rate a moving target.</span>
                                        </p>
                                        <p>
                                        Every country has its own mortality rate. Italy's case-fatality-rate is about 12% while Germany's is 1%. The virus itself is not more potent in Italy, but rather the differences can be explained by how rigorously countries are testing and counting the number of infections and deaths. A country's age demographic and healthcare infrastructure have been shown to play a role in determining this number.
                                        </p>
                                    </section>
                                        </Col>

                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>   
                                    <img src='./jpg/ifr.png' className="fluid" alt=""/>
                                    <br/>
                                    <br/>
                                        <p>
                                        <span className="font600">The infection-fatality-rate (IFR) is the proportion of people who die out of the actual number of people who were infected.</span>
                                        </p>
                                        <p>
                                            If 1,000 people have COVID-19 and only 100 of those test positive, then if 10 people were to die, the (IFR) would be 1% - much less than the case-fatality-rate (CFR), but still higher than the seasonal flu.
                                        </p>
                                        <p>
                                        <span className="font600">The infection-fatality-rate is the mortality rate most of us are actually looking for.</span>
                                        </p>
                                        <p>
                                        As several reports have suggested, COVID-19's infection-fatality-rate is probably lower than initially estimated, mainly due to many cases going undiagnosed.
                                        </p>
                                    </section>
                                    </Col>
                                </Row>
                                <br/>


                                <Row className="boxcard">
                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>
                                    <p className="text-center font-600 pad30 display-5">
                                    CONFIRMED RECOVERIES
                                    </p>
                                    <img src='./jpg/recover.gif' className="fluid" alt=""/>
                                    <br/>
                                    <br/>
                                    <p>
                                    The overwhelming majority of people who contract COVID-19 get better. According to the WHO, the virus typically lasts about two weeks for mild cases and three to six weeks for serious cases. 
                                    </p>
                                    <p>
                                    <span className="font600">It is important to remember that most coronavirus cases are mild.</span>
                                    </p>
                                    <p>
                                    Keeping an eye on recoveries should help avoid unnecessary global panic and help individuals better understand the risks to themselves and their community.
                                    </p>
                                    <p>
                                    <span className="font600">There is a lot of uncertainty in calculating this figure.</span> So much so that Johns Hopkins University temporarily suspended its reporting of recovered cases citing <a href ="https://github.com/CSSEGISandData/COVID-19/issues/1250" target="_blank" rel="noopener noreferrer">"no reliable data source reporting recovered cases for many countries, such as the US"</a>, before resuming its tally a few days later.
                                    </p>
                                    </section>
                                        </Col>

                                    <Col xl="6" xs="12"  className="text-left">
                                    <section>   
                                    <p className="text-center font-600 pad30 display-5">
                                    CONFIRMED ACTIVE CASES
                                    </p>
                                    <img src='./jpg/active.png' className="fluid" alt=""/>
                                    <br/>
                                    <br/>
                                        <p>
                                        If you want to know how many people are currently infected, you need to take the number of confirmed cases and subtract those people who have recovered or died from the virus.
                                        </p>
                                        <p>
                                        Even if a country currently has a low number of confirmed cases, it is important to keep in mind that <span className="font600">most countries show very similar traits in how the disease spreads.</span> Initially, the numbers may seem small, but due to the virus's exponential nature, the numbers multiply quickly.
                                        </p>
                                        <p>
                                        In an ideal situation, extrapolating patterns from countries with early outbreaks, including China, South Korea and Italy, would help other countries inform their respective response strategies. <span className="font600">The problem is that, especially in the case of China, there have been accusations that the official figures underreport the number of cases.</span> 
                                        </p>
                                    </section>
                                    </Col>
                                </Row>

                                <br/>
                                <br/>
                                <div className="feedbackbox feedgreen">
                                    <p className="text-center font-600 display-5">Which number is the most meaningful to you?</p>{textselect}
                                </div>


                                    {feedquestion1}
                                    {thankyou}
                                
                            </Col>

                        </Row>

                    </Container>
                </Container>
                
            </div>
        )
    }
}
export default Part1